import { PackageType, useGetAllPackagesQuery } from '../../types';

export interface UsePackageQueriesResult {
  rows: PackageType[];
  loading: boolean;
  hasError: boolean;
}

const EMPTY_ROWS: PackageType[] = [];

export const usePackageQueries = (): UsePackageQueriesResult => {
  const { data, loading, error } = useGetAllPackagesQuery();

  return {
    rows: data?.getAllPackages ?? EMPTY_ROWS,
    loading,
    hasError: !!error,
  };
};
